import { callDeleteApi, callGetApi, callPostApi, callPutApi } from "../interceptor";

// Get Subscription Extend Requests List API function
export async function getSubscriptionExtendRequests(data) {
  try {
    const response = await callPostApi({ url: "subscription-extend-requests/list", body: data });
    return response;
  } catch (error) {
    throw error;
  }
}



// Update Subscription Extend Request API function
export async function updateSubscriptionExtendRequest(id, data) {
  try {
    const response = await callPutApi({ 
      url: `subscription-extend-requests/${id}`, 
      body: data 
    });
    return response;
  } catch (error) {
    throw error;
  }
}

// Get Pending Subscription Extend Requests Count API function
export async function getPendingSubscriptionExtendRequestsCount() {
  try {
    const response = await callGetApi({ url: "subscription-extend-requests/pending/count" });
    return response;
  } catch (error) {
    throw error;
  }
}